import { Button, Collapse, FormGroup, Intent, TextArea } from "@blueprintjs/core";
import EditorToaster from "core/components/editor/EditorToaster";
import { IFieldProps } from "decorator-form";
import React from "react";


interface IJsonFieldState {
	editing: boolean;
	value: string;
}

export default class JsonField extends React.Component<IFieldProps<object>, IJsonFieldState> {

	public state = { editing: false, value: "" };

	public render() {
		const { schema } = this.props;

		return (
			<FormGroup label={schema.title} helperText={schema.description}>
				<Button small={true} text="Edit JSON" active={this.state.editing} onClick={this.toggleEdit} />
				<div style={{paddingTop: '15px'}}>
					<Collapse isOpen={this.state.editing}>
						<FormGroup>
							<TextArea value={this.state.value} onChange={this.onChange} />
						</FormGroup>
						<FormGroup>
							<Button small={true} text="Save" onClick={this.save} />
						</FormGroup>
					</Collapse>
				</div>
			</FormGroup>
		);
	}

	private onChange = (e: any) => this.setState({value: e.target.value});

	private toggleEdit = () => {
		if (!this.state.editing) {
			this.setState({
				editing: true,
				value: JSON.stringify(this.props.formData)
			});
		} else {
			this.setState({editing: false});
		}
	}

	private save = () => {
		try {
			const o = JSON.parse(this.state.value);
			this.props.onChange(o);
			EditorToaster.show({
				message: "Saved JSON",
				intent: Intent.SUCCESS
			});
		} catch (e) {
			EditorToaster.show({
				message: "Invalid JSON",
				intent: Intent.DANGER
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/common/form/fields/JsonField.tsx